kombi.flatpickrInstances = [];

/** Local YYYY-MM-DD (avoids toISOString timezone cost/skew in hot calendar paths). */
kombi.fp_date_key = function (dateObj) {
    if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
        return "";
    }
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return year + "-" + month + "-" + day;
};

kombi.fp_can_stay = function (start, end, calendar) {
    let currentDate = new Date(start);
    let dateStr = kombi.fp_date_key(currentDate);
    let duration = (end - start) / 86400000;
    if (start == end || duration < calendar[dateStr].min_stay || duration > calendar[dateStr].max_stay) {
        return false;
    }
    while (currentDate < end) {
        if (!calendar[dateStr] || calendar[dateStr].available <= 0) {
            return false;
        }
        currentDate.setDate(currentDate.getDate() + 1);
        dateStr = kombi.fp_date_key(currentDate);
    }
    return true;
}

kombi.fp_can_start_stay = function (start, calendar) {
    let currentStayStart = new Date(start);
    let currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    let dateStr = kombi.fp_date_key(currentStayStart);
    let antecedence = calendar[dateStr].antecedence;
    if (currentStayStart < currentDate.fp_incr(antecedence)) {
        return false;
    }
    // check that all days between start and min_stay are available
    let min_stay = calendar[dateStr].min_stay;
    let end = currentStayStart.fp_incr(min_stay);
    while (currentStayStart < end) {
        if (!calendar[dateStr] || calendar[dateStr].available <= 0) {
            return false;
        }
        currentStayStart.setDate(currentStayStart.getDate() + 1);
        dateStr = kombi.fp_date_key(currentStayStart);
    }
    return true;
}

/** Date accepts a check-in: has inventory, arrival is open and antecedence/min-stay fit. */
kombi.fp_can_arrive = function (dateObj, calendar) {
    const calendarDay = calendar ? calendar[kombi.fp_date_key(dateObj)] : null;
    if (!calendarDay) {
        return false;
    }
    return (
        calendarDay.available > 0 &&
        !calendarDay.closed_on_arrival &&
        kombi.fp_can_start_stay(dateObj, calendar)
    );
};

/** Day availability + pricing shared by the desktop popup and the mobile modal (onDayCreate). */
kombi.fp_apply_day_rules = function (fp, dayElem) {
    if (!fp.calendar || Object.keys(fp.calendar).length === 0) {
        return;
    }

    const calendarDay = fp.calendar[kombi.fp_date_key(dayElem.dateObj)] || null;
    const canArrive = kombi.fp_can_arrive(dayElem.dateObj, fp.calendar);
    let showMinStay = false;

    if (kombi.calendarDayPrice) {
        kombi.calendarDayPrice.decorateDayElement(dayElem, calendarDay, canArrive);
    }

    if (!calendarDay) {
        if (
            !(fp.selecting_stay && kombi.fp_can_stay(fp.selecting_stay, dayElem.dateObj, fp.calendar))
        ) {
            dayElem.classList.add("flatpickr-disabled");
        }
        return;
    }

    if (!fp.selecting_stay) {
        if (canArrive) {
            showMinStay = true;
        } else {
            dayElem.classList.add("flatpickr-disabled");
        }
    } else if (dayElem.dateObj.getTime() === fp.selecting_stay.getTime()) {
        dayElem.classList.add("flatpickr-disabled", "selecting");
        showMinStay = true;
    } else if (
        !(
            dayElem.dateObj >= fp.selecting_stay &&
            kombi.fp_can_stay(fp.selecting_stay, dayElem.dateObj, fp.calendar) &&
            !calendarDay.closed_on_departure
        )
    ) {
        dayElem.classList.add("flatpickr-disabled");
    }

    // Touch has no hover: the tip must exist in the DOM, CSS reveals it on .selecting.
    if (showMinStay) {
        const tooltip = document.createElement("span");
        tooltip.classList.add("calendar-tooltip");
        tooltip.textContent = "Mín de " + calendarDay.min_stay + " noite(s)";
        dayElem.appendChild(tooltip);
    }
};

/**
 * Show Melhores preços / Entrada indisponível legends when hotel calendar API data exists
 * (Hotel or Package with hotel). Rates note ("Tarifas estimadas...") only on Hotel tab.
 * Empty payload ({}) / cleared hotel → hide.
 */
kombi.setCalendarLegendVisibility = function (fp) {
    const container = fp.calendarContainer;
    if (!container) return;
    const hasCalendarData = !!(fp.calendar && Object.keys(fp.calendar).length > 0);
    const isPackage =
        kombi.calendarDayPrice &&
        typeof kombi.calendarDayPrice.isPackageActive === "function" &&
        kombi.calendarDayPrice.isPackageActive();
    const showRatesNote = hasCalendarData && !isPackage;
    const legendContainer = container.querySelector(".calendar-legends");
    if (legendContainer) {
        legendContainer.classList.toggle("d-none", !hasCalendarData);
        legendContainer.classList.toggle("d-flex", hasCalendarData);
    }
    const ratesNote = container.querySelector(".calendar-rates-note");
    if (ratesNote) {
        ratesNote.classList.toggle("d-none", !showRatesNote);
        ratesNote.setAttribute("aria-hidden", showRatesNote ? "false" : "true");
    }
};

kombi.syncAllCalendarLegendVisibility = function () {
    (kombi.flatpickrInstances || []).forEach(function (fp) {
        kombi.setCalendarLegendVisibility(fp);
    });
};

kombi.flatpickr = function () {
    /**
     * Package (search): lead time is read from <body data-package-lead-days="N"> (set by backend).
     * First allowed check-in = today + N + 1 (exclusive: today+N is not selectable).
     * Hotel: keeps new Date().fp_incr(1).
     */
    const HOTEL_MAX_ADVANCE_DAYS = 540;
    const DEFAULT_PACKAGE_MAX_ADVANCE_DAYS = 365;
    const DEFAULT_PACKAGE_LEAD_DAYS = 5;

    function getPackageLeadDays() {
        var raw = document.body && document.body.dataset
            ? document.body.dataset.packageLeadDays
            : null;
        var parsed = parseInt(raw, 10);
        return (parsed === parsed && parsed >= 0) ? parsed : DEFAULT_PACKAGE_LEAD_DAYS;
    }

    function getPackageMinDate() {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + getPackageLeadDays() + 1);
        return d;
    }

    function readPackageMaxAdvanceDays(el) {
        const raw =
            (el && el.getAttribute("data-package-max-advance-days")) ||
            (document.querySelector("[data-package-max-advance-days]") &&
                document
                    .querySelector("[data-package-max-advance-days]")
                    .getAttribute("data-package-max-advance-days"));
        const parsed = parseInt(raw, 10);
        return Number.isFinite(parsed) && parsed > 0
            ? parsed
            : DEFAULT_PACKAGE_MAX_ADVANCE_DAYS;
    }

    function getPackageMaxDate(el) {
        return new Date().fp_incr(readPackageMaxAdvanceDays(el));
    }

    function isPackageActive() {
        return !!(
            kombi.searchTabs &&
            typeof kombi.searchTabs.isPackageActive === "function" &&
            kombi.searchTabs.isPackageActive()
        );
    }

    function getMinDateForCurrentTab() {
        if (isPackageActive()) {
            return getPackageMinDate();
        }
        return new Date().fp_incr(1);
    }

    function getMaxDateForCurrentTab(el) {
        if (isPackageActive()) {
            return getPackageMaxDate(el);
        }
        return new Date().fp_incr(HOTEL_MAX_ADVANCE_DAYS);
    }

    function clearDatesIfOutsideRange(fp, minDate, maxDate) {
        const el = fp.element;
        const d0 = el.querySelector(".dates-0");
        const d1 = el.querySelector(".dates-1");
        const minTs = minDate.getTime();
        const maxTs = maxDate.getTime();
        const inRange = function (d) {
            const ts = d.getTime();
            return ts >= minTs && ts <= maxTs;
        };
        let dates = fp.selectedDates || [];
        if (dates.length < 2 && d0 && d0.value && d1 && d1.value) {
            const hiddenStart = fp.parseDate(d0.value, "Y-m-d");
            const hiddenEnd = fp.parseDate(d1.value, "Y-m-d");
            if (hiddenStart && hiddenEnd) {
                dates = [hiddenStart, hiddenEnd];
            }
        }

        // Hidden inputs are the stay source of truth. Tab change must not destroy a
        // Hotel-valid stay just because Package cannot show it — park it on the input.
        if ((!dates.length || dates.some(function (d) { return !inRange(d); })) &&
            d0 && d0.dataset.parkedStay && d1 && d1.dataset.parkedStay) {
            const start = fp.parseDate(d0.dataset.parkedStay, "Y-m-d");
            const end = fp.parseDate(d1.dataset.parkedStay, "Y-m-d");
            if (start && end && inRange(start) && inRange(end)) {
                d0.value = d0.dataset.parkedStay;
                d1.value = d1.dataset.parkedStay;
                fp.setDate([start, end], false);
                delete d0.dataset.parkedStay;
                delete d1.dataset.parkedStay;
                return false;
            }
        }

        const hasInvalid = dates.some(function (d) {
            return !inRange(d);
        });
        if (!hasInvalid) {
            if (dates.length >= 2) {
                if (d0) delete d0.dataset.parkedStay;
                if (d1) delete d1.dataset.parkedStay;
            }
            return false;
        }
        // Always overwrite: an older parked stay must not outlive a newer one.
        if (d0 && d0.value) {
            d0.dataset.parkedStay = d0.value;
            if (d1) d1.dataset.parkedStay = d1.value;
        }
        fp.clear();
        if (d0) d0.value = "";
        if (d1) d1.value = "";
        return true;
    }

    /**
     * Anchor the package view to the first bookable month. Without a selection the view is
     * always pulled back — a cleared Hotel stay would otherwise leave it months ahead.
     * With a selection, only when the visible month is before the package minimum.
     */
    function anchorPackageViewToMinMonth(fp, minDate) {
        const hasSelection = fp.selectedDates && fp.selectedDates.length > 0;
        const viewMonthStart = new Date(fp.currentYear, fp.currentMonth, 1);
        const minMonthStart = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
        if (!hasSelection || viewMonthStart < minMonthStart) {
            fp.jumpToDate(minDate);
        }
    }

    /** Legends match product mocks for Hotel and Package: Melhores preços + Entrada indisponível. */
    function getCalendarLegendsInnerHTML() {
        const firstLegend =
            '<div class="legend d-flex align-items-center mt-1 w-auto">' +
            '<div class="legend-color best-prices rounded-circle me-3" style="width: 15px; height: 15px; flex-shrink: 0;"></div><span class="text-start lh-1 fs-0_8rem">Melhores preços</span>' +
            "</div>";
        const secondLegend =
            '<div class="legend d-flex align-items-center mt-1 w-auto">' +
            '<div class="position-relative me-3" style="width: 15px; height: 15px; flex-shrink: 0;">' +
            '<div class="legend-color date-unavailable rounded-circle" style="width: 15px; height: 15px;"></div>' +
            '<div class="border-top border-2 position-absolute top-50 translate-middle-y" style="left: -3.5px; right: -3px; border-color: #626262 !important;"></div>' +
            "</div>" +
            '<span class="text-start lh-1 fs-0_8rem">Entrada indisponível</span>' +
            "</div>";
        return firstLegend + secondLegend;
    }

    function updateAllCalendarLegendsForTab() {
        const html = getCalendarLegendsInnerHTML();
        kombi.flatpickrInstances.forEach(function (fp) {
            const legendContainer = fp.calendarContainer && fp.calendarContainer.querySelector(".calendar-legends");
            if (legendContainer) {
                legendContainer.innerHTML = html;
            }
            kombi.setCalendarLegendVisibility(fp);
        });
    }

    function syncClearButtonState(fp) {
        if (!fp || !fp.calendarContainer) return;
        const clearBtn = fp.calendarContainer.querySelector(".calendar-btn-clear");
        if (!clearBtn) return;
        const selected = fp.selectedDates || [];
        clearBtn.disabled = selected.length === 0;
    }

    function isStayComplete(fp) {
        const dates = (fp && fp.selectedDates) || [];
        return dates.length === 2 && dates[0].getTime() < dates[1].getTime();
    }

    /**
     * Muted state for Avançar while the range is incomplete. Never `disabled`: the click
     * has to reach the handler so the validation tooltip can explain what is missing.
     */
    function syncConfirmButtonState(fp) {
        if (!fp || !fp.calendarContainer) return;
        const confirmBtn = fp.calendarContainer.querySelector(".calendar-btn-confirm");
        if (!confirmBtn) return;
        const complete = isStayComplete(fp);
        confirmBtn.classList.toggle("calendar-btn--muted", !complete);
        confirmBtn.setAttribute("aria-disabled", complete ? "false" : "true");
        if (complete) kombi.hideValidationTooltip();
    }

    /** Desktop: center dual-month popup under .nav-search (measured, not CSS tokens). */
    function centerCalendarUnderSearchBar(fp) {
        const cal = fp && fp.calendarContainer;
        if (
            !cal ||
            cal.classList.contains("calendar-mobile__fp") ||
            !window.matchMedia("(min-width: 992px)").matches
        ) {
            return;
        }
        const bar =
            (fp.element && fp.element.closest(".nav-search")) ||
            document.querySelector(".d-sm-block .nav-search");
        if (!bar || !cal.offsetWidth) return;

        const barRect = bar.getBoundingClientRect();
        cal.style.left =
            barRect.left + (barRect.width - cal.offsetWidth) / 2 + window.pageXOffset + "px";
        cal.style.right = "auto";
        cal.style.transform = "none";
        cal.classList.remove("rightMost", "centerMost");
    }

    function clearCalendarDates(fp, rootItem) {
        if (!fp || !rootItem) return;
        const currentMonth = fp.currentMonth;
        const currentYear = fp.currentYear;
        fp.selecting_stay = null;
        fp.clear();
        fp.jumpToDate(new Date(currentYear, currentMonth));
        const startInput = rootItem.querySelector(".dates-0");
        const endInput = rootItem.querySelector(".dates-1");
        if (startInput) {
            startInput.value = "";
            delete startInput.dataset.parkedStay;
        }
        if (endInput) {
            endInput.value = "";
            delete endInput.dataset.parkedStay;
        }
        syncClearButtonState(fp);
        syncConfirmButtonState(fp);
    }

    /**
     * Flatpickr weekday headers: single letter (D S T Q Q S S), matching the search calendar mock.
     */
    function getCalendarLocale(localeCode) {
        const code = localeCode || "pt";
        const base =
            typeof flatpickr !== "undefined" &&
            flatpickr.l10ns &&
            flatpickr.l10ns[code]
                ? flatpickr.l10ns[code]
                : null;
        if (!base) return code;
        return Object.assign({}, base, {
            weekdays: Object.assign({}, base.weekdays, {
                shorthand: ["D", "S", "T", "Q", "Q", "S", "S"],
            }),
        });
    }

    // Search desktop (#search-calendar-desk). Mobile search uses calendarMobile (inline modal).
    // https://flatpickr.js.org/
    document.querySelectorAll(".flatpickr").forEach((item) => {
        let enableTime = this.getBoolAttr(item, "data-enable-time", false);
        let initialHotel = item.getAttribute("data-initial-hotel") || null;
        let opts = {
            mode: item.getAttribute("data-mode") || "single",
            enableTime: enableTime,
            noCalendar: this.getBoolAttr(item, "data-no-calendar", false),
            inline: this.getBoolAttr(item, "data-inline", false),
            animate: this.getBoolAttr(item, "data-animate", false),
            position: "auto",
            dateFormat:
                item.getAttribute("data-date-format") || (enableTime ? "H:i" : "Y-m-d"),
            disableMobile: this.getBoolAttr(item, "data-disable-mobile", true),
            defaultDate: item.getAttribute("data-default-date")?.split(",") || null,
            altInput: this.getBoolAttr(item, "data-alt-input", true),
            altFormat:
                item.getAttribute("data-alt-format") || (enableTime ? "H:i" : "d/m/y"),
            locale: getCalendarLocale(item.getAttribute("data-locale") || "pt"),
            minDate: item.getAttribute("data-min-date") || getMinDateForCurrentTab(),
            maxDate: item.getAttribute("data-max-date") || getMaxDateForCurrentTab(item),
            wrap: this.getBoolAttr(item, "data-wrap", false),
            showMonths: 2,
            // Keep open after range select; user confirms with footer Avançar.
            closeOnSelect: false,
            // Month label is text-only; avoid dropdown jumps. Year input is locked in onReady/CSS.
            monthSelectorType: "static",
            onOpen: function(selectedDates, dateStr, instance) {
                const searchControlsRoot =
                    item.closest(".nav-search") ||
                    item.closest("#SearchForm .pattern-form");
                if (searchControlsRoot && kombi.closeNavSearchDropdowns) {
                    kombi.closeNavSearchDropdowns(searchControlsRoot);
                }
                if (this.config.mode == "range") {
                    if (instance.selectedDates.length === 1) {
                        instance.selectedDates = [];
                    }
                    instance.selecting_stay = null;
                    instance.redraw();
                }
                syncClearButtonState(instance);
                syncConfirmButtonState(instance);
                if (isPackageActive() && instance.config.mode === "range") {
                    anchorPackageViewToMinMonth(instance, getPackageMinDate());
                }
                // Width may settle after Flatpickr's first position pass.
                requestAnimationFrame(function () {
                    centerCalendarUnderSearchBar(instance);
                });
                if (kombi.calendarDayPrice) {
                    kombi.calendarDayPrice.refreshOnCalendarOpen();
                }
            },
            onClose: function (selectedDates) {
                if (this.config.mode === "range") {
                    const startInput = item.querySelector(".dates-0");
                    const endInput = item.querySelector(".dates-1");
                    const incompleteRange =
                        selectedDates.length === 1 ||
                        (selectedDates.length === 2 &&
                            selectedDates[0].getTime() >= selectedDates[1].getTime());

                    // Incomplete selection must not persist a lone check-in into hidden inputs.
                    if (incompleteRange) {
                        this.selecting_stay = null;
                        this.clear();
                        if (startInput) startInput.value = "";
                        if (endInput) endInput.value = "";
                        return;
                    }

                    this.selecting_stay = null;
                    if (selectedDates[0] && startInput) {
                        startInput.value = this.formatDate(selectedDates[0], "Y-m-d");
                        // Confirming a stay makes any parked one obsolete.
                        delete startInput.dataset.parkedStay;
                    }
                    if (selectedDates[1] && endInput) {
                        endInput.value = this.formatDate(selectedDates[1], "Y-m-d");
                        delete endInput.dataset.parkedStay;
                    }
                }
            },
            onChange: function (selectedDates, dateStr, instance) {
                if (instance.config.mode == "range" && selectedDates.length === 1) {
                    instance.selecting_stay = selectedDates[0];
                    instance.redraw();
                } else {
                    instance.selecting_stay = null;
                }
                syncClearButtonState(instance);
                syncConfirmButtonState(instance);
            },
            onDayCreate: function (dObj, dStr, fp, dayElem) {
                kombi.fp_apply_day_rules(fp, dayElem);
            },
            onReady: function(selectedDates, dateStr, instance) {
                if (!instance.calendarContainer) return;

                const legendsHtml = getCalendarLegendsInnerHTML();

                const footerWrap = document.createElement("div");
                footerWrap.classList.add("calendar-footer-wrap", "mx-2", "mt-1");

                const ratesNote = document.createElement("div");
                ratesNote.classList.add(
                    "calendar-rates-note",
                    "d-none",
                    "pb-2",
                    "fs-0_8rem",
                    "text-gray-650",
                    "text-end",
                );
                ratesNote.textContent = "Tarifas estimadas para 02 adultos";
                ratesNote.setAttribute("aria-hidden", "true");

                const footer = document.createElement("div");
                footer.classList.add(
                    "calendar-footer",
                    "d-flex",
                    "align-items-center",
                    "justify-content-between",
                    "gap-3",
                    "pt-2",
                    "border-top",
                );

                const legendContainer = document.createElement("div");
                legendContainer.classList.add(
                    "calendar-legends",
                    "d-flex",
                    "align-items-center",
                    "gap-4",
                    "flex-wrap"
                );
                legendContainer.innerHTML = legendsHtml;

                const actions = document.createElement("div");
                actions.classList.add(
                    "calendar-actions",
                    "d-flex",
                    "align-items-center",
                    "gap-2",
                    "flex-shrink-0",
                    "ms-auto"
                );
                actions.innerHTML =
                    '<button type="button" class="btn btn-sm btn-outline-primary rounded-pill calendar-btn-clear px-3 py-2" disabled>Limpar</button>' +
                    '<button type="button" class="btn btn-sm btn-primary rounded-pill calendar-btn-confirm calendar-btn--muted px-3 py-2" aria-disabled="true">Avançar</button>';

                footer.appendChild(legendContainer);
                footer.appendChild(actions);
                footerWrap.appendChild(ratesNote);
                footerWrap.appendChild(footer);
                instance.calendarContainer.appendChild(footerWrap);

                actions.querySelector(".calendar-btn-clear").addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (e.currentTarget.disabled) return;
                    clearCalendarDates(instance, item);
                });
                actions.querySelector(".calendar-btn-confirm").addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (!isStayComplete(instance)) {
                        kombi.showValidationTooltip(e.currentTarget, kombi.tooltips.dateRequired);
                        return;
                    }
                    instance.close();
                });
                syncClearButtonState(instance);
                syncConfirmButtonState(instance);
                kombi.setCalendarLegendVisibility(instance);
            },
        };

        let fpInstance = flatpickr(item, opts);
        fpInstance.calendar = null;
        fpInstance.selecting_stay = null;
        fpInstance.calendar_url = item.getAttribute("data-calendar-url") || null;
        fpInstance.initialHotel = initialHotel;
        // After every Flatpickr position (open/resize), fix horizontal align to .nav-search.
        const positionCalendar = fpInstance._positionCalendar.bind(fpInstance);
        fpInstance._positionCalendar = function () {
            positionCalendar();
            centerCalendarUnderSearchBar(fpInstance);
        };
        kombi.flatpickrInstances.push(fpInstance);
    });

    if (this.flatpickrInstances.length > 0) {
        if (this.flatpickrInstances[0].initialHotel && this.flatpickrInstances[0].calendar_url) {
            this.updateCalendar(this.flatpickrInstances[0].initialHotel);
        }
    }

    if (!kombi._searchTabChangeFlatpickrBound) {
        kombi._searchTabChangeFlatpickrBound = true;
        document.addEventListener("searchtab:change", function (e) {
            const isPackage = e.detail && e.detail.isPackage;
            kombi.flatpickrInstances.forEach(function (fp) {
                const minDate = isPackage ? getPackageMinDate() : new Date().fp_incr(1);
                const maxDate = isPackage
                    ? getPackageMaxDate(fp.element)
                    : new Date().fp_incr(HOTEL_MAX_ADVANCE_DAYS);
                fp.set("minDate", minDate);
                fp.set("maxDate", maxDate);
                clearDatesIfOutsideRange(fp, minDate, maxDate);
                if (isPackage) {
                    anchorPackageViewToMinMonth(fp, minDate);
                }
                fp.redraw();
            });
            updateAllCalendarLegendsForTab();
            if (kombi.calendarDayPrice) {
                kombi.calendarDayPrice.refetchForCurrentMode();
            }
            kombi.flatpickrInstances.forEach(function (fp) {
                if (fp.isOpen) centerCalendarUnderSearchBar(fp);
            });
        });
    }
};

kombi.updateCalendar = function (hotel_pk) {
    // Keep mobile resolveHotelPk in sync with search-bar hotel selection/clear.
    // Otherwise detail-page data-initial-hotel (e.g. Blue Tree) sticks after a switch/clear.
    document
        .querySelectorAll("#calendar-mobile-mount, .calendar-mobile-trigger")
        .forEach(function (el) {
            if (hotel_pk) {
                el.setAttribute("data-initial-hotel", String(hotel_pk));
            } else {
                el.removeAttribute("data-initial-hotel");
            }
        });
    (this.flatpickrInstances || []).forEach(function (fp) {
        fp.initialHotel = hotel_pk || null;
    });

    // Instance URL first; DOM fallback for mobile calendar (no .flatpickr instance).
    const calendar_url =
        (this.flatpickrInstances[0] && this.flatpickrInstances[0].calendar_url) ||
        (document.querySelector("[data-calendar-url]") &&
            document.querySelector("[data-calendar-url]").getAttribute("data-calendar-url")) ||
        null;
    if (kombi.calendarDayPrice) {
        return kombi.calendarDayPrice.fetchCalendar(calendar_url, hotel_pk);
    }
    if (hotel_pk && calendar_url) {
        fetch(`${calendar_url}?hotel_pk=${hotel_pk}`)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                this.flatpickrInstances.forEach((fp) => {
                    fp.calendar = data;
                    fp.redraw();
                });
                this.syncAllCalendarLegendVisibility();
            });
    } else {
        this.flatpickrInstances.forEach((fp) => {
            fp.calendar = null;
            fp.redraw();
        });
        this.syncAllCalendarLegendVisibility();
    }
};

kombi.openDatePicker = function () {
    const flatpickrElements = document.querySelectorAll('.flatpickr');
    let flatpickrElement;
    if (window.matchMedia("(min-width: 992px)").matches) {
        flatpickrElement = flatpickrElements[0];
    } else {
        const modalElement = document.getElementById("SearchForm");
        let modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (!modalInstance) {
            modalInstance = new bootstrap.Modal(modalElement);
        }
        modalInstance.show();
        flatpickrElement = flatpickrElements[1];
    }
    if (flatpickrElement) {
        const flatpickrInstance = flatpickrElement._flatpickr;
        if (flatpickrInstance) {
            flatpickrInstance.open();
        } else {
            flatpickrElement.click();
        }
    }
};